import { fetchOptions, handleResponse } from '@/common/apiCalls';
import Configs from '@/Configs';

/** Locales persisted on the employee record and supported by platform i18n bundles. */
export const PREFERRED_LANGUAGE_OPTIONS = ['en', 'es', 'en-GB', 'es-ES'] as const;

export type PreferredLanguage = (typeof PREFERRED_LANGUAGE_OPTIONS)[number];

/**
 * PATCH preferred language for the authenticated employee.
 *
 * @param companyID
 * @param employeeID
 * @param preferredLanguage
 * @param token
 * @param correlationId
 */
export async function patchEmployeePreferredLanguage(
  companyID: number,
  employeeID: number,
  preferredLanguage: PreferredLanguage,
  token: string,
  correlationId: string | null = null
) {
  const response = await fetch(
    `${Configs.platformPatchEmployeePreferredLanguageAPI}?companyID=${companyID}&employeeID=${employeeID}`,
    fetchOptions('PATCH', { preferredLanguage }, token, 'json', correlationId)
  );

  return handleResponse(response);
}
